<template>

	<div class="container  bg_main paddingb80">


		<!-- 状态 -->
		<div v-if="detail.stateIcon" class="fullwidth padding715">
			<div class=" bg_white radius10 padding10 flex_row">
				<img mode="widthFix" class="inline width30 autoheight " :src="detail.stateIcon " />
				<div class="fullwidth marginl10">
					<div class="color_blue bold">{{detail.stateDisplay}}</div>
					<div class="color2 ">{{detail.stateNote}}</div>
				</div>
			</div>
		</div>


		<!-- 地址 -->
		<div class="fullwidth padding715">
			<div class="bg_fff radius10">
				<div class="flex_row padding010 ">
					<div class="bold">
						<div class="uni-icon uni-icon-info-filled size2r marginr5 color_000 middle"></div>
						<div class="inline middle">收货人信息</div>
					</div>
				</div>

				<div v-if="tip=='need_addr'" class="fullwidth left paddingl10 color_red">需要收货地址</div>

				<div @click="toAddrList"   :class="'flex_row '+(tip=='need_addr'?'bg_fcc':'') ">
					<div class="ellips">{{detail.contactModel && detail.contactModel.address?detail.contactModel.address:"我的收货地址"}}</div>
					<div>
						<img src="@/assets/images/arrow_right.png" class="width18 height18" />
					</div>
				</div>
			</div>
		</div>


		<!-- <div bindtap="getWxAddr" class="flex_row">
		    <div wx:if="{{!!orderAddr.isWxAddr==true}}">{{orderAddr.address}}</div>
		    <div wx:else>采用微信地址</div>
		    <div>
		      <img src="../../../images/arrow_right.png" class="arrow_right" />
		    </div>
		  </div>
		
		
		  <div wx:if="{{orderAddr && orderAddr.address && !!orderAddr.isWxAddr==false}}" bindtap="toAddrList" class="flex_row">
		    <div>{{orderAddr.address}}</div>
		    <div>
		      <img src="../../../images/arrow_right.png" class="arrow_right" />
		    </div>
		  </div>
		  <div wx:else bindtap="toAddrEdit" class="flex_row">
		    <div>新增收货地址</div>
		    <div>
		      <img src="../../../images/arrow_right.png" class="arrow_right" />
		    </div>
		  </div> -->





		<div class="padding715 fullwidth">
			<div class="bg_fff radius10">

				<div class="flex_row">
					<div class="bold">
						<div class="uni-icon uni-icon-info-filled size2r marginr5 color_000 middle"></div>
						<div class="inline middle">商品</div>
					</div>
					<div>
						数量 <div class="inline color_red marginr10">{{detail.count}} </div>
						金额 <div class="inline color_red"> ￥{{detail.goodsAmount}}</div>
					</div>
				</div>


				<div class="fullwidth padding010">
					<scroll-view class="overhide nowrap " scroll-x="true" bindscroll="scroll">
						<div v-for="(item,index) in detail.goodsList" class="inline relative" :key="item.id" :index="index">
							<img :src="item.imgArr[0]" class="width80 autoheight" mode="widthFix" />
							<div class=" width80 overhide ellips size4 padding5 marginr5  ">
								{{item.name}}
							</div>
							<div
								class="absolute top0 right5 size5 nowrap width24 height24 center lineh24 bg_red color5 radius100">
								{{item.currOrderCount}}
							</div>
						</div>
					</scroll-view>
				</div>

				<!-- <div wx:for="{{goodsList}}" wx:key="item" class="  flex_row">
					<img src="{{item.img}}" class="width80 autoheight" mode="widthFix" />
					<div class=" flex1 padding0 marginl10">
					<div class="flex_row padding0">
						<div class="inline">{{item.name}}</div>
					</div>
					<div wx:for="{{item.goodsSpecList}}" wx:for-item="item2" class="flex_row padding0 company_item">
						<div class="inline">{{item2.name}}</div>
						<div>
						<div class="inline">{{item2.price}}</div>
						<div class="inline size5">X{{item2.currOrderCount}}</div>
						</div>
					</div>
					</div>
				</div> -->

				<div class="flex_row">
					<div class="bold">
						<div class="uni-icon uni-icon-info-filled size2r marginr5 color_000 middle"></div>
						<div class="inline middle">运费</div>
					</div>
					<div>￥{{detail.peisongAmount}}</div>
				</div>

				<div class="padding10 fullwidth">
					<input v-if="isShowInput" class="padding10   height60r border" type="text" data-name="note"
						v-model="detail.note" placeholder="给卖家留言..." />
				</div>

			</div>
		</div>


		<div v-if="user.coupon>0 && detail.isCanPay===1" class="padding715 fullwidth">
			<div class="bg_fff radius10">
				<div class="hidden flex_row">
					<div>优惠券</div>
					<div>￥{{discount}}</div>
				</div>

				<div class="flex_row">
					<div>是否使用现金券</div>
					<div>
						<div class="inline middle ">￥{{user.coupon}}</div>
						<img v-if="user.coupon>0 && isUseCoupon " @click="setUseCoupon"
							class="marginl10 width24 height24 middle" mode="widthFix" src="@/assets/images/select.png" />
						<img v-if="user.coupon>0 && !isUseCoupon " @click="setUseCoupon"
							class="marginl10 width24 height24 middle" mode="widthFix" src="@/assets/images/select2.png" />
					</div>
				</div>
				<div v-if="useCoupon>0" class="fullwidth padding10 right">
					即将用掉<div class="inline color_red">￥{{useCoupon}}</div>
					余<div class="inline color_red">￥{{balanceCoupon}}</div>
				</div>
			</div>
		</div>

		<div class="padding715 fullwidth">
			<div class="bg_fff radius10">
				<div class="flex_row">
					<div class="bold">
						<div class="uni-icon uni-icon-info-filled size2r marginr5 color_000 middle"></div>
						<div class="inline middle">应付</div>
					</div>
					<div class="color_red">￥{{detail.goodsAmount + detail.peisongAmount - useCoupon - discount - paidCash - paidCoupon }}</div>
				</div>
			</div>
		</div>
		

		<div v-if="!!detail.id==true" class="padding715 fullwidth">
			<div class="bg_fff radius10 padding10">
				<div class="flex_row padding0  ">
					<div class="bold">
						<div class="uni-icon uni-icon-info-filled size2r marginr5 color_000 middle"></div>
						<div class="inline middle">进度</div>
					</div>
					<div class="color3">编号 {{detail.id}}</div>
				</div>
				<div v-for="(item,index) in detail.stateList" v-bind:key="index" class="flex_row padding0 margint10 ">
					<div>{{item.stateDisplay}}</div>
					<div>{{item.createTimeDisplay}}</div>
				</div>
			</div>
		</div>

		

		<!-- 操作 -->
		<div class="fixed bottom0 fullwidth h5maxwidth bg_main padding10 automargin" >
			<div class=" flex_row padding0">

				<div v-if="detail.isCanShowPosition==1 "
					@click="toPosition(detail.id,detail.shop.latitude,detail.shop.longitude) "
					class="flex1 marginl5 marginr5 radius20 center padding10 bg_green color5">位置</div>

				<div v-if="detail.isCanPay==1 || !!detail.id==false" @click="createOrder" 
					class="flex1 marginl5 marginr5 radius20 center padding10 bg_red color5">支付</div>

				<div v-if="detail.isCanDetele==1" @click="cancelOrder(detail.id)"
					class="flex1 marginl5 marginr5 radius20 center padding10 bg_green color5">取消</div>

				<div v-if="detail.isCanEvaluate==1" @click="toEvaluate(detail.id)"
					class="flex1 marginl5 marginr5 radius20 center padding10 bg_green color5 ">评价</div>

				<div v-if="detail.isCanRefund==1" @click="toRefund(detail.id)"
					class="flex1 marginl5 marginr5 radius20 center padding10 bg_green color5">退款</div>

				<div v-if="detail.isCanReceived==1" @click="doReceived(detail.id)"
					class="flex1 marginl5 marginr5 radius20 center padding10 bg_green color5">确认收货</div>

			</div>
		</div>



		<!-- <popup_input id='popup_input' :img='qrcodeUrl' text='请输入现金券的支付密码' btn_no='取消' btn_ok='确定' bind:error="popError"
			bind:success="popSuccess" /> -->

	</div>


</template>

<script>
	// #ifdef H5
	//import jQuery from "@/common/jquery.js";
	// #endif
	const DETAIL_PAGE_PATH = '/pages/goods/detail';
	// const app = getApp();

	function _handleShareChannels(provider) {
		let channels = [];
		for (let i = 0, len = provider.length; i < len; i++) {
			switch (provider[i]) {
				case 'weixin':
					channels.push({
						text: '分享到微信好友',
						id: 'weixin',
						sort: 0
					});
					channels.push({
						text: '分享到微信朋友圈',
						id: 'weixin',
						sort: 1
					});
					break;
				default:
					break;
			}
		}
		channels.sort(function(x, y) {
			return x.sort - y.sort;
		});
		return channels;
	}

	export default {
		data() {
			return {
				user: { coupon:0 },
				selectedPriceIndex: 0,
				
				// 订单数据
				// id,org_index,uid,device_id,goods_list_json,contact_id,goods_amount,peisong_amount
				// count,weight,note,create_time,state,pay_detail,pay_state,pay_time,
				// refund_operater,refund_time,refund_reason,appid,deliver_sn,order_type
				detail: {
					goodsList: [], //订单
					contact: {},
					note: "",
					orderAddr: {},
					totalCount: 0,
					goodsAmount: 0,
					peisongAmount: 0,
				},
					

				htmlNodes: [],

				
				discount: 0,
				paidCash: 0,//已付金额
				paidCoupon: 0,//已付现金券

				qrcodeUrl: '',
				useCoupon: 0,
				balanceCoupon: 0,
				isShowInput: true,

				isUseCoupon: false,
				tip:"",//错误提示
			}
		},
		created() {
			console.log("created");
			var that = this;
			this.user = window.$utils.uniapi.getStorageSync("user") || {};
			var options=this.$route.query || {};

			this.loadData(options.id);

			// if (options && typeof options.id != 'undefined' && !!options.id == true) {
			// 	//从订单发起，开始支付
			// 	this.id= options.id;
			// 	this.getOrderDetail(options.id, function(d) {
			// 		// that.goodsList = d.goodsList;
			// 		that.detail = d;

			// 		//计算总价
			// 		that.countGoodsList();

			// 		that.getPeisongAmount(function(){ });
			// 	});
			// } else {
			// 	//从购物车，开始订购
			// 	var cartGoodsList = window.$utils.uniapi.getStorageSync('cartGoodsList') || [];
			// 	//uni.removeStorageSync('cartGoodsList');
			// 	console.log(cartGoodsList);
			// 	this.detail.goodsList = cartGoodsList;
			// 	//计算总价
			// 	this.countGoodsList();

			// 	that.getPeisongAmount(function(){ });
			// }

			// //查询用户信息
			// this.getUserInfo(function(){});
			

			//this.sendMsg();
			//this.popupInput = this.selectComponent("#popup_input");

			
		},
		mounted() {
			console.log("mounted");

			//更新地址
			var selectedContact = window.$utils.uniapi.getStorageSync('selectedContact') || null;
			console.log("1",selectedContact);
			if (selectedContact != null) {
				window.$utils.uniapi.removeStorageSync('selectedContact');
				this.detail.contactModel = selectedContact;
				this.detail.contactId = selectedContact.id;
			}else{
				this.getLastAddress();
			}
			console.log("2",selectedContact);
			
			
			//恢复数据
			this.tip="";
			
			
		},
		onShareAppMessage() {
			return {
				title: "share me",
				path: DETAIL_PAGE_PATH + '?detailDate=' + JSON.stringify(this.goods)
			}
		},
		onNavigationBarButtonTap(event) {
			const buttonIndex = event.index;
			if (buttonIndex === 0) {
				// 分享 H5 的页面
				const shareProviders = [];
				// uni.getProvider({
				// 	service: 'share',
				// 	success: (result) => {
						
				// 	},
				// 	fail: (error) => {
				// 		uni.showToast({
				// 			title: '获取分享服务失败'
				// 		});
				// 	}
				// });
			}
		},
		methods: {
			
			loadData(id){
				var that=this;
				if ( typeof id != 'undefined' && !!id == true ) {
					//从订单发起，开始支付
					this.id= id;
					this.getOrderDetail(id, function(d) {
						// that.goodsList = d.goodsList;
						that.detail = d;

						//是否有部分支付
						if(!!that.detail.payDetail==true){
							var pay_detail_obj=JSON.parse(that.detail.payDetail);
							if(typeof pay_detail_obj.cash!='undefined'){
								that.paidCash=pay_detail_obj.cash;
							}
							if(typeof pay_detail_obj.coupon!='undefined'){
								that.paidCoupon=pay_detail_obj.coupon;
							}
						}

						//计算总价
						that.countGoodsList();

						that.getPeisongAmount(function(){ });
					});
				} else {
					//从购物车，开始订购
					// var cartGoodsList = window.$utils.uniapi.getStorageSync('cartGoodsList') || [];
					// this.detail.goodsList = cartGoodsList;
					this.getList(function(){
						//计算总价
						that.countGoodsList();
						//计算运费
						that.getPeisongAmount(function(){ });

						that.showButtonByCart();//购物车订单时，按钮设置
					});
					
				}

				//查询用户信息
				this.getUserInfo(function(){});
			},

			

			getList(callback) {
				var that = this;
				this.status = "loading";
				var cartGoodsList = window.$utils.uniapi.getStorageSync('cartGoodsList') || [];
				var ids="";
				for(var i=0;i<cartGoodsList.length;i++){
					ids+=cartGoodsList[i].id+",";
				}
				if(ids==''){ return; }
				ids=ids.substring(0,ids.length-1);
				this.$axios.request({
						url: window.$config.url.getGoodsList,
						data: { page: 1, pageSize:30,  ids:ids }
					})
					.then(res => {
						if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {
							this.detail.goodsList = res.data.list; 
							this.status = this.page >= this.totalPage ? "nomore" : 'more';
							this.fromCart();
							if(typeof callback=='function')callback();
						} else if (!!res.msg == true) {
							alert( res.msg );
						} else {
							alert("不成功" );
						}
					});

			},
			/**
			 * 从购物车采集订购数据
			 * 商品数据获取完成后，初始购物车
			 */
			fromCart() {
				var that = this;
				this.cartGoodsList = window.$utils.uniapi.getStorageSync('cartGoodsList') || [];
				//初始商品选购数量
				var goodsList = this.detail.goodsList;
				for (var g = 0; g < goodsList.length; g++) {
					var isInCart = false; //
					//在购物车中的按购物车数据
					for (var c = 0; c < this.cartGoodsList.length; c++) {
						if (goodsList[g].id == this.cartGoodsList[c].id) {
							//商品当前订购数量
							goodsList[g].currOrderCount = this.cartGoodsList[c].currOrderCount;
							//进一步赋值规格订购数量
							for(var cs = 0; cs < this.cartGoodsList[c].goodsSpecList.length; cs++){
								for (var gs = 0; gs < goodsList[g].goodsSpecList.length; gs++) {
									if(goodsList[g].goodsSpecList[gs].id==this.cartGoodsList[c].goodsSpecList[cs].id){
										goodsList[g].goodsSpecList[gs].currOrderCount=this.cartGoodsList[c].goodsSpecList[cs].currOrderCount;
									}
								}
							}
							isInCart = true;break;
						}
					}
					if (!isInCart) {
						//清空数量
						goodsList[g].currOrderCount = 0;
						for (var gs = 0; gs < goodsList[g].goodsSpecList.length; gs++) {
							goodsList[g].goodsSpecList[gs].currOrderCount = 0;
						}
					}
				}
				this.detail.goodsList = goodsList;

				// this.countCart();
				this.$forceUpdate();
			},
			
			
			//合计订购数量金额
			countGoodsList(callback) {
				var totalCount = 0;
				var goodsAmount = 0;
				var goodsList = this.detail.goodsList;
				
				//var cartGoodsList=[];
				for (var i = 0; i < goodsList.length; i++) {
					for (var p = 0; p < goodsList[i].goodsSpecList.length; p++) {
						if (goodsList[i].goodsSpecList[p].currOrderCount <= 0) continue;
						totalCount += goodsList[i].goodsSpecList[p].currOrderCount;
						goodsAmount += goodsList[i].goodsSpecList[p].currOrderCount * goodsList[i].goodsSpecList[p].price;
					}
				}
				this.detail.count = totalCount;
				this.detail.goodsAmount = parseFloat(goodsAmount.toFixed(2));
				if (typeof callback == "function") callback();

			},

		
			
			// saveOrder() {
			// 	this.$axios.request({
			// 			url: window.$config.url.saveOrder,
			// 			data: {
			// 				goodsListJson: toOrderGoodsListParam(),//JSON.stringify(this.goodsList),
			// 				note: this.note,
			// 				contactId: this.contact.id
			// 			}
			// 		})
			// 		.then(res => {
			// 			if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {
			// 				uni.stopPullDownRefresh();
			// 				uni.showToast({
			// 					title: res.msg,
			// 					icon: "none"
			// 				});
			// 				this.toPay();

			// 			} else if (!!res.msg == true) {
			// 				uni.showToast({
			// 					title: res.msg,
			// 					icon: "none"
			// 				});
			// 			} else {
			// 				uni.showToast({
			// 					title: "不成功",
			// 					icon: "none"
			// 				});
			// 			}
			// 		});

			// },
			toPay() {

				this.$router.push({path:'/order_pay',query:{}});  
			},

			/**
			 * 配送费
			 */
			getPeisongAmount: function(callback) {
				var that = this;
				if (this.detail.goodsList.length == 0) {
					window.$utils.uniapi.showToast({
						title: '需要选择商品',
						icon: "none"
					})
					return;
				}
				//参数
				var params = {
					orgIndex: this.detail.goodsList[0].orgIndex,
					goodsAmount: this.detail.goodsAmount
				};
				this.$axios.request({
						url: window.$config.url.getPeisongAmount,
						data: params
					})
					.then(res => {
						that.isLoadFinished= true;
						if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {
							//var state = res.data.data.state;
							var peisongAmount = res.data;
							that.detail.peisongAmount = peisongAmount;
							if (typeof callback == "function") callback();
						}
					});
			},

			getUserInfo(callback) {
				console.log("查询现金券");
				var that = this;
				var user = window.$utils.uniapi.getStorageSync("user") || {};
				if (typeof user.id == "undefined" || user.id == null) {
					console.log("没有uid");
					return false;
				}
				window.$utils.getUserInfo(that,function(res) {
					that.user= res;
					if (typeof callback == 'function') { callback(); }
				});
			},


			toAddrList() {
				console.log("toAddrList", this.detail.isCanPay);
				if( typeof this.detail.isCanPay!='undefined' && this.detail.isCanPay != 1 ){
					console.log("需支付前操作");
					return;
				}
				this.$router.push({path:'/order_addr_list',query:{action:"from_order"}}); 
			},
			getLastAddress() {
				console.log("getLastAddress ================");
				var that = this;
				var user = window.$utils.uniapi.getStorageSync("user") || {};
				if (typeof user.id == "undefined" || user.id == null) {
					console.log("没有uid");
					return false;
				}
				var params={};
				this.$axios.request({
						url: window.$config.url.getLastOrderContact,
						data: params
					})
					.then(res => {
						that.isLoadFinished = true;
						if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {
							var d = res.data;
							that.detail.contactModel = d;
						}
					});
			},




			/**
			 * 查询商家
			 */
			getShopDetail: function(id) {
				console.log("查询商家详情");
				var that = this;
				var user = window.$utils.uniapi.getStorageSync("user") || {};
				if (typeof user.id == "undefined" || user.id == null) {
					console.log("没有uid");
					return false;
				}
				if (id == null || id == "") {
					console.log("没有id");
					return false;
				}
				var params = {
					mid: user.id,
					id: id
				};
				this.$axios.request({
						url: window.$config.url.getShopDetail,
						data: params
					})
					.then(res => {
						that.isLoadFinished = true;
						if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {

							var shop = res.data;
							var lnglatArr = window.$utils.bMapToQQMap(shop.longitude, shop.latitude);
							//var lnglatArr = util.bMapToQQMap(118.100377, 24.482443);
							shop.longitude = lnglatArr[0];
							shop.latitude = lnglatArr[1];
							shop.placeList = res.data.areas;
							for (var i = 0; i < shop.placeList.length; i++) {
								shop.placeList[i].img = window.$config.imgUrlRoot + shop.placeList[i].img;
							}
							that.shop = shop;
						}

					})
				//requestTask.abort() // 取消请求任务
			},

			//详情
			getOrderDetail: function(id, callback) {
				var that = this;
				if (typeof id == "undefined" || id == "" || id == null) {
					console.log("没有ID");
					return;
				}
				//时间控制
				var currtime = new Date().getTime();
				if (currtime < this.lastGetOrderDetailTime + 1000) {
					return;
				}
				this.lastGetOrderDetailTime = currtime;
				console.log("详情");
				var that = this;
				var user = window.$utils.uniapi.getStorageSync("user") || {};
				if (typeof user.id == "undefined") {
					window.$utils.uniapi.showToast({
						title: '请先登录',icon:"none",
						complete: function() {
							this.$router.push({ path: "/user_login" });
						}
					});
					return false;
				}
				var params = {
					mid: user.id,
					id: id,
				};
				this.$axios.request({
						url: window.$config.url.getOrderDetail,
						data: params
					})
					.then(res => {
						that.isLoadFinished = true;
						if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {

							var d = res.data;
							d=that.fitData(d);
							
							if (typeof callback == "function") callback(d);
						}
					});
			},
			fitData(orderObj) {
				if (orderObj == null) return orderObj;

				//商品
				orderObj.goodsList = JSON.parse(orderObj.goodsListJson);

				//订单状态
				if (orderObj.stateList != null) {
					for (var i = 0; i < orderObj.stateList.length; i++) {
						orderObj.stateList[i].createTimeDisplay = window.$utils.dateUtils.getTimeStr(orderObj.stateList[i].createTime);
					}
				}

				//按钮控制
				//orderObj.isCanShowPosition=1;
				if (typeof orderObj.state=='undefined' || !!orderObj.state==false 
					|| orderObj.state == window.$config.state.order_create
					|| orderObj.state.endsWith( window.$config.state.order_pay_part )
					) {
					orderObj.isCanPay = 1;
				}
				if (orderObj.state == window.$config.state.order_create) {
					orderObj.isCanDetele = 1;
				}
				if (orderObj.state.indexOf(window.$config.state.order_goods_send_finish) >= 0) {
					orderObj.isCanEvaluate = 1;
				}
				if (orderObj.state.indexOf(window.$config.state.order_pay_finish) >= 0 &&
					orderObj.state.indexOf(window.$config.state.order_peisong_called) < 0 &&
					orderObj.state.indexOf(window.$config.state.order_goods_to_peisong) < 0 &&
					orderObj.state.indexOf(window.$config.state.order_goods_send_finish) < 0
				) orderObj.isCanRefund = 0; //暂不退款
				if (orderObj.state.indexOf(window.$config.state.order_goods_to_peisong) >= 0) orderObj.isCanReceived = 1;


				//最后状态图标
				var lastState = orderObj.state.split(",")[orderObj.state.split(",").length - 1];
				if (lastState == window.$config.state.order_create) orderObj.stateIcon = "order_wait_pay_on.png";
				else if (lastState == window.$config.state.order_pay_finish) orderObj.stateIcon =
				"order_wait_peisong_on.png";
				else if (lastState == window.$config.state.order_goods_to_peisong) orderObj.stateIcon =
					"order_peisong_on.png";
				else if (lastState == window.$config.state.order_goods_send_finish) orderObj.stateIcon =
					"order_wait_pingjia_on.png";
				else orderObj.stateIcon = "success.png";

				orderObj.stateIcon=require('@/assets/images/'+orderObj.stateIcon);
				return orderObj;
			},

			//购物车时按钮控制
			showButtonByCart(){
				this.detail.isCanPay=1;
				// this.detail.isCanDetele=1;
			},

			

			/**
			 * 转为订单商品参数
			 * 订单商品必要参数  [{id,goodsSpecList:[{id,currOrderCount}]}]
			 */
			toOrderGoodsListParam(){
				var arr=[];
				for(var i=0;i<this.detail.goodsList.length;i++){
					var obj={};
					obj.id=this.detail.goodsList[i].id;
					obj.goodsSpecList=[];
					
					var speclist=this.detail.goodsList[i].goodsSpecList;
					for(var m=0;m<speclist.length;m++){
						if(speclist[m].currOrderCount>0){
							var specObj={};
							specObj.id=speclist[m].id;
							specObj.currOrderCount=speclist[m].currOrderCount;
							obj.goodsSpecList.push(specObj);
						}
					}
					arr.push(obj);
				}
				return JSON.stringify(arr);
			},

			
			/**
			 * 创建订单
			 * mid	string		是	会员id
			   orderInfos			是	订单商品信息
			      addressId：收货地址id；remarks：订单备注；peisongAmount：快递费；cartId：购物车商品id，如果是从商品中直接下单的，可不传； 
			 */
			createOrder: function() {
				var that = this;
				if (!!this.id == true) {
					console.log("直接支付订单");
					this.doPay(this.id);
					return;
				}
				console.log("创建订单");

				var orderAddr = that.detail.contactModel;
				if ( !!orderAddr == false || !!orderAddr.id == false ) {
					window.$utils.uniapi.showToast({
						title: '需收货地址', icon: "none"
					});
					this.tip="need_addr";
					return false;
				}
				var user = window.$utils.uniapi.getStorageSync("user") || {};
				if (typeof user.id == "undefined" || user.id == null) {
					console.log("没有uid");
					window.$utils.uniapi.showToast({ title: '需登录', icon: "none" });
					return false;
				}
				
				//参数
				var params = {
					goodsListJson: this.toOrderGoodsListParam(),//JSON.stringify(this.goodsList),
					note: this.detail.note,
					contactId: orderAddr.id
				};
				this.$axios.request({
						url: window.$config.url.createOrder,
						data: params
					})
					.then(res => {
						that.isLoadFinished = true;
						if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {

							//var state = res.data.data.state;
							var orderId = res.data.id;
							that.doPay(orderId);
							//uni.removeStorage({ key: 'cartGoodsList', })
							//uni.removeTabBarBadge({ index: 2 });
							
						}else if(!!res.msg == true){
							window.$utils.uniapi.showToast({ title:res.msg,icon:"none" })
						}
					});

			},

			/**
			 * 是否手机访问
			 */
			isPhone(){
				return window.$utils.uniapi.isMobileDevice();
			},
			doPay(orderId) {

				var that = this;
				//采用不同支付方式
				if (that.useCoupon > 0) {
					// that.popOpen(function(d){
					//   that.couponPaywd=d;
					that.payByCoupon(orderId, function() {
						if (that.detail.goodsAmount + that.detail.peisongAmount > that.useCoupon) {
							// #ifdef MP-WEIXIN
							// that.toWxpay(orderId);
							// #endif
							
							// #ifdef H5
							if(that.isPhone()){
								console.log("手机端");
								that.payByWap(orderId, function(url){
									//if(url.indexOf("%22")<0){ url=encodeURIComponent(url); }
									window.$utils.uniapi.setStorageSync("common_web_url",url);
									//内部方式
									// window.$utils.uniapi.navigateTo({ url:"/pages/common/web?url="+url });
									that.$router.push({ path: "/common_web",query:{url:url} });
									//外部浏览器
									//plus.runtime.openURL(url);
									//window.$utils.uniapi.navigateTo({ url:"plugin://NativePlugin/webview?url="+url });
									
								})
							}else{
								console.log("电脑端11");
								var qrPayMode="2";//跳转
								that.payByPage(orderId,qrPayMode, function(url){
									
									console.log("电脑端12  qrPayMode="+qrPayMode);
									if(qrPayMode=="2"){
										//外部浏览器
										if(window){
											console.log("电脑端14 window");
											window.open(url,"_self");
											//window.location.href=url;
										}
										else if(plus){
											console.log("电脑端15 plus");
											plus.runtime.openURL(url);
										}
										//window.$utils.uniapi.navigateTo({ url:"plugin://NativePlugin/webview?url="+url });
									
									}else{
										//内部方式
										console.log("电脑端13 内部方式 "+qrPayMode);
										//if(url.indexOf("%22")<0){ url=encodeURIComponent(url); }
										window.$utils.uniapi.setStorageSync("common_web_url",url);
										// window.$utils.uniapi.navigateTo({ url:"/pages/common/web?url="+url });
										that.$router.push({ path: "/common_web",query:{url:url} });
									
									}
								})
							}
							// #endif
						} else {
							//window.$utils.uniapi.redirectTo({ path: '/order_list', });
							that.$router.push({ path: "/order_list" });
						}
					});
					// });



				} else {
					
					// #ifdef MP-WEIXIN
					// that.toWxpay(orderId);
					// #endif
					
					// #ifdef H5
					if(that.isPhone()){
						console.log("手机端");
						that.payByWap(orderId, function(url){ 
							//内部方式
							//if(url.indexOf("%22")<0){ url=encodeURIComponent(url); }
							window.$utils.uniapi.setStorageSync("common_web_url",url);
							// window.$utils.uniapi.navigateTo({ url:"/pages/common/web?url="+url });
							that.$router.push({ path: "/common_web",query:{url:url} });
							//外部浏览器
							//plus.runtime.openURL(url);
							//window.$utils.uniapi.navigateTo({ url:"plugin://NativePlugin/webview?url="+url });
						})
					}else{
						// 如果想打开web url，
						// 在App平台可以使用 plus.runtime.openURL 或web-view组件；
						// H5平台使用 window.open；
						// 小程序平台使用web-view组件（url需在小程序的联网白名单中）。
						// 在hello uni-app中有个组件ulink.vue已对多端进行封装，可参考。
						console.log("电脑端");
						var qrPayMode="2";//跳转
						that.payByPage(orderId,qrPayMode, function(url){
							console.log("电脑端22  qrPayMode="+qrPayMode);
							if(qrPayMode=="2"){
								//外部浏览器
								//支付完成后返回: http://47.120.53.189/pages/order/detail?charset=UTF-8&out_trade_no=m54ven06Kc0BNd&method=alipay.trade.page.pay.return&total_amount=0.03&sign=e92p1ZPkFsmCHoMM2ZDAKoFav4XzwxWRDtKdOPZ%2BzLVq0aVjEn4bcJdEl2Hd3V7fRQu8P5f9HQPgDJGOvp%2Fm9vndy0pqZpj5bCLZFzGcFb5ATHJtxpYqvGR0Gu0%2B4MXEWQxEfNzV6tB%2FL4%2BMw88U8FnKEpyXG6nUYcyvCay4tZZmu1ln3Cm2pTY5zpoPdBZE41ClL5lPhs5BsZleLFE%2BbQRsxOI0CWyKikO8UZcI2ykAYSbKlYH%2FSDlWfsHHCksBFeIl0%2B1oCBVOP9rYCzyv6KOBJX%2BdGlgu57qD%2BxPVUSklu19daVC5vPO1diiHj%2BFx9NHu1JpbXjy%2FdngD1Zr%2BpA%3D%3D&trade_no=2024122622001496891449018862&auth_app_id=2021004142640068&version=1.0&app_id=2021004142640068&sign_type=RSA2&seller_id=2088340594219465&timestamp=2024-12-26+13%3A16%3A29
								if(window){
									console.log("电脑端24 window");
									window.open(url,"_self");
									//window.location.href=url;
								}
								else if(plus){
									console.log("电脑端25 plus");
									plus.runtime.openURL(url);
								}
								//window.$utils.uniapi.navigateTo({ url:"plugin://NativePlugin/webview?url="+url });
							
							}else{
								//内部方式
								console.log("电脑端23 内部方式 "+qrPayMode);
								//if(url.indexOf("%22")<0){ url=encodeURIComponent(url); }
								window.$utils.uniapi.setStorageSync("common_web_url",url);
								// window.$utils.uniapi.navigateTo({ path:"/common_web",query:{url:url }});
								that.$router.push({ path: "/common_web",query:{url:url} });
							
							}
						})
					}
					// #endif
				}


			},


			popOpen(callback) {
				try {
					this.popupInput.showPopup();
				} catch (e) {
					console.log(e);
				}
				this.isShowInput= false;
				this.popCallback = callback;
			},
			//取消事件
			popError() {
				console.log('你点击了取消');
				this.popupInput.hidePopup();
				//window.$utils.uniapi.navigateBack();
				this.isShowInput= true;
			},
			//确认事件
			popSuccess(e) {
				console.log('你点击了确定', e.detail);
				this.popupInput.hidePopup();

				//this.updatePhone(e.detail);
				this.isShowInput= true;

				if (typeof this.popCallback == "function") {
					this.popCallback(e.detail);
				}
			},

			/**
			 * 获取请求参数{orderTimes,price}
			 */
			getReqParams: function() {
				var that = this;
				var params = {};
				var reserveTime1 = 24;
				var reserveTime2 = 0;
				var price = that.selectedPlace[0].price; //场地单一价格
				var date = that.selectedPlace[0].date; //订单仅允许同一天
				for (var i = 0; i < that.selectedPlace.length; i++) {
					//reserveTime += that.selectedPlace[i].time + ",";
					if (that.selectedPlace[i].time < reserveTime1) {
						reserveTime1 = that.selectedPlace[i].time;
					}
					if (that.selectedPlace[i].time > reserveTime2) {
						reserveTime2 = that.selectedPlace[i].time;
					}
					//price += that.selectedPlace[i].price;
				}
				if (reserveTime1 == reserveTime2) {
					params.orderTimes = reserveTime1 + ":00-" + (reserveTime1 + 1) + ":00";
				} else {
					params.orderTimes = reserveTime1 + ":00-" + (reserveTime2 + 1) + ":00";
				}
				params.price = price;
				params.orderDateStr = date;
				return params;
			},


			//是否需要发票
			checkboxChange: function(event) {
				console.log('checkbox发生change事件，携带value值为：', event.detail.value)
				if (event.detail.value == 1) {
					//this.data.goodsAmount = (this.data.goodsAmount*1.2).toFixed(2);
					this.detail.goodsAmount = Math.round((this.detail.goodsAmount * 1.2) * 100 / 100).toFixed(2);
					this.isNeedBill = 1;
				} else {
					//this.data.goodsAmount = (this.data.goodsAmount / 1.2).toFixed(2);
					this.detail.goodsAmount = Math.round((this.detail.goodsAmount / 1.2) * 100 / 100).toFixed(2);
					this.isNeedBill = 0;
				}
			},


			changePhoneInput: function(e) {
				//console.log(e);
				var phone = e.detail.value;
				if (phone != null && phone.length == 11) {
					this.phone = phone;
				}
			},



			//去支付（同步pages/order_list/order_list修改）
			toWxpay: function(id) {

				console.log("获取统一支付数据");
				var that = this;
				var user = window.$utils.uniapi.getStorageSync("user") || {};
				if (!user || typeof user.id == "undefined") {
					window.$utils.uniapi.showToast({
						title: '请先登录',icon:"none",
						complete: function() {
							this.$router.push({ path: "/user_login" });
						}
					});
					return false;
				}
				var params = {
					orderId: id,
				};
				this.$axios.request({
						url: window.$config.url.getWxmpPayParams,
						data: params
					})
					.then(res => {
						that.isLoadFinished = true;
						if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {
				
							var resParams = res.data;
							window.$utils.uniapi.requestPayment({
								'timeStamp': resParams.timeStamp + "",
								'nonceStr': resParams.nonceStr,
								'package': resParams.package,
								'signType': resParams.signType,
								'paySign': resParams.paySign,
								'success': function(res) {
									console.log(res);
									window.$utils.uniapi.showToast({
										title: '支付成功',
									});
								},
								'fail': function(res) {
									console.log(res);
									window.$utils.uniapi.showToast({
										title: '不成功',
										image: '../../../images/warn.png'
									});
								},
								'complete': function(res) {
									console.log(res);
									// window.$utils.uniapi.redirectTo({ url: '/pages/order/order_list/order_list', });
									this.$router.push({ path: "/order_list" });
								}
							});
						}else{
							window.$utils.uniapi.showToast({ title:res.msg,icon:"none" });
						}
				});
			},


			payByCoupon: function(id, callback) {
				console.log("现金券支付订单");
				var that = this;

				//用户
				var user = window.$utils.uniapi.getStorageSync("user") || {};
				if (typeof user.id == "undefined" || user.id == null) {
					console.log("没有uid");
					return false;
				}
				//请求
				var params = {
					orderId: id,
					coupon: that.useCoupon
				};
				this.$axios.request({
						url: window.$config.url.payByCoupon,
						data: params
					})
					.then(res => {
						that.isLoadFinished = true;
						if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {
							if (typeof callback == "function") callback();
						}else{
							window.$utils.uniapi.showToast({ title:res.msg,icon:"none" });
						}
					});
			},

			payByWap: function(id, callback) {
				console.log("payByWap支付订单");
				var that = this;
				//用户
				var user = window.$utils.uniapi.getStorageSync("user") || {};
				if (typeof user.id == "undefined" || user.id == null) {
					console.log("没有uid");
					return false;
				}
				//请求
				var params = {
					orderId: id,
					//returnUrl:window.$config.appHost+"/pages/order/detail",
					//quitUrl:window.$config.appHost+"/pages/order/detail"
				};
				this.$axios.request({
						url: window.$config.url.payByWap,
						data: params
					})
					.then(res => {
						that.isLoadFinished = true;
						if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {
							if (typeof callback == "function") callback(res.data);
						}else{
							window.$utils.uniapi.showToast({ title:res.msg,icon:"none" });
						}
					});
					
			},
			payByPage: function(id,qrPayMode, callback) {
				console.log("payByPage 电脑支付订单");
				var that = this;
				//用户
				var user = window.$utils.uniapi.getStorageSync("user") || {};
				if (typeof user.id == "undefined" || user.id == null) {
					console.log("没有uid");
					return false;
				}
				//请求
				var params = {
					orderId: id,
					qrPayMode:qrPayMode,
					returnUrl:window.$config.appHost+window.$config.appBasePath+"/order_confirm",
					quitUrl:window.$config.appHost+window.$config.appBasePath+"/order_confirm"
				};
				this.$axios.request({
						url: window.$config.url.payByPage,
						data: params
					})
					.then(res => {
						that.isLoadFinished = true;
						if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {
							if (typeof callback == "function") callback(res.data);
						}else{
							window.$utils.uniapi.showToast({ title:res.msg,icon:"none" });
						}
					});
					
			},
			
			// sendMsg(){
			// 	 window.postMessage({ readFlag: false }, '*')
			// },
			
			setUseCoupon(){
				if(this.isUseCoupon){
					this.isUseCoupon=false;
				}else{
					this.isUseCoupon=true;
				}
				
				if(this.isUseCoupon){
					var useCoupon=this.user.coupon>(this.detail.goodsAmount+this.detail.peisongAmount-this.paidCash-this.paidCoupon)
						?(this.detail.goodsAmount+this.detail.peisongAmount-this.paidCash-this.paidCoupon)
						:this.user.coupon;
					useCoupon=useCoupon.toFixed(2);
					this.useCoupon=useCoupon;
					var balanceCoupon=this.user.coupon-useCoupon;
					balanceCoupon=balanceCoupon.toFixed(2);
					this.balanceCoupon=balanceCoupon;
				}else{
					this.useCoupon=0;
					this.balanceCoupon=this.user.coupon;
				}
			},

			cancelOrder() {
				console.log("cancelOrder");
				var that = this;
				var user = window.$utils.uniapi.getStorageSync("user") || {};
				if (!user || typeof user.id == "undefined") {
					alert('请先登录' );
					return false;
				}
				var params = {
					orderId: this.detail.id,
				};
				this.$axios.request({
						url: window.$config.url.cancelOrder,
						data: params
					})
					.then(res => {
						// uni.stopPullDownRefresh();
						if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {
							alert( '成功' );
							that.loadData(that.detail.id);
						}
					});
			},


		}
	}
</script>

<style scoped>
	.banner {
		height: 180px;
		overflow: hidden;
		position: relative;
		background-color: #ccc;
	}

	.banner-img {
		width: 100%;
	}

	.banner-title {
		max-height: 42px;
		overflow: hidden;
		position: absolute;
		left: 15px;
		bottom: 15px;
		width: 90%;
		font-size: 16px;
		font-weight: 400;
		line-height: 21px;
		color: white;
		z-index: 11;
	}

	.article-meta {
		padding: 10px 20px;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		color: gray;
	}

	.article-text {
		font-size: 13px;
		line-height: 25px;
		margin: 0 10px;
	}

	.article-author,
	.article-time {
		font-size: 15px;
	}

	.article-content {
		padding: 0 15px;
		overflow: hidden;
		font-size: 15px;
		margin-bottom: 15px;
	}
</style>


// WEBPACK FOOTER //
// src/views/order/confirm.vue